import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getSessionId = () => {
  let sessionId = sessionStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

const shouldSkipTracking = (page) => {
  // Skip if on admin route
  const path = (typeof window !== 'undefined' && window.location && window.location.pathname) || '';
  if (path.startsWith('/admin')) return true;

  // Skip if page prop indicates admin
  if (typeof page === 'string' && /^\/?(admin|dashboard)/i.test(page)) return true;

  // Skip ONLY if the logged-in user is an admin — regular customers still count
  try {
    const rawUser = localStorage.getItem('user');
    if (rawUser) {
      const u = JSON.parse(rawUser);
      if (u && u.is_admin === true) return true;
    }
  } catch (e) {
    /* ignore storage / JSON errors */
  }

  return false;
};

export const useAnalytics = (page, options = {}) => {
  const { eventType, vehicleId } = options;

  useEffect(() => {
    if (shouldSkipTracking(page)) return;

    const trackPageView = async () => {
      try {
        const sessionId = getSessionId();
        const referrer = document.referrer || 'direct';
        const userAgent = navigator.userAgent;

        await axios.post(`${API}/analytics/track`, {
          session_id: sessionId,
          page: page,
          event_type: eventType || 'page_view',
          vehicle_id: vehicleId || null,
          referrer: referrer,
          user_agent: userAgent
        });
      } catch (error) {
        // Silently fail - analytics shouldn't break the app
      }
    };

    trackPageView();
  }, [page, eventType, vehicleId]);
};
